import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'de',
    debug: true,
    interpolation: {
      escapeValue: false,
    },
    backend: {
      loadPath: '/locales/{{lng}}/translation.json',
    },
    // Website-Texte aus AgoraHub (editTexts.js) werden nachtraeglich als Ressourcen eingespielt; 'added' sorgt dafuer,
    // dass jedes t() danach neu zeichnet (auch im Bearbeitungsmodus nach jeder Aenderung).
    react: {
      bindI18nStore: 'added',
    },
  });

export default i18n;